import { SvgIconProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import MediationIcon from '@mui/icons-material/Mediation';
import { createUseStyles } from 'react-jss';

// Custom icon that rotates MediationIcon 90 degrees counter-clockwise

const useStyles = createUseStyles({
  icon: {
    transform: 'rotate(-90deg)',
  },
});

const RotatedMediationIcon = (props: SvgIconProps) => {
  const styles = useStyles();

  return <MediationIcon {...props} className={styles.icon} />;
};

// Add muiName property to match IconElementType interface
(
  RotatedMediationIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & { muiName: string }
).muiName = 'RotatedMediationIcon';

export default RotatedMediationIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};
